module.exports = __webpack_public_path__ + "static/media/totalemi.6bdafa15.png";